/**
 * 계좌 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class AccountService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 계좌 비밀번호 재설정
     * 개설한 계좌의 비밀번호를 재설정한다.
     * @returns 계좌 비밀번호 재설정 결과
     */
    resetPassword(request) {
        return this.axios.put(`/main/v1/accounts/reset-pw`, request);
    }
    /**
     * 계좌 정보 조회
     * 회원의 계좌 정보를 조회한다.
     * @returns 계좌 정보 조회 결과
     */
    getAccountInfo() {
        return this.axios.get(`/main/v1/accounts/info`);
    }
    /**
     * 계좌 정보 변경
     * 계좌 정보(별칭, 표시여부, 표시순번)를 변경한다.
     * @returns 계좌 정보 변경 결과
     */
    updateAccountInfo(request) {
        return this.axios.put(`/main/v1/accounts/info`, request);
    }
    /**
     * 계좌 비밀번호 변경
     * 개설한 계좌의 비밀번호를 변경한다.
     * @returns 계좌 비밀번호 변경 결과
     */
    updatePassword(request) {
        return this.axios.put(`/main/v1/accounts/change-pw`, request);
    }
    /**
     * 출금신청
     * 계좌에서 출금을 신청한다.
     * @returns 출금신청 결과
     */
    requestWithdrawal(request) {
        return this.axios.post(`/main/v1/accounts/withdrawal`, request);
    }
    /**
     * 입금신청
     * 계좌에 입금을 신청한다.
     * @returns 입금신청 결과
     */
    requestDeposit(request) {
        return this.axios.postForm(`/main/v1/accounts/deposit`, request);
    }
    /**
     * 계좌 개설
     * 회원가입 후 계좌를 개설한다. 기존 계좌의 존재여부와 상관없이 원장서버로 요청을 보낸다.
     * @returns 계좌 개설 결과
     */
    createAccount(request) {
        return this.axios.post(`/main/v1/accounts/create`, request);
    }
    /**
     * 출납신청 조회
     * 회원의 계좌 출납신청 정보를 조회한다.
     * @param request - 출납신청 조회 요청 데이터
     * @returns 출납신청 조회 결과
     */
    getDepositsWithdrawalsInfo(request) {
        return this.axios.get(`/main/v1/accounts/deposits-withdrawals/info`, {
            params: request,
        });
    }
    /**
     * 모의용 출납처리
     * 계좌의 예수금을 입금한다. 이외(출금) 에 대해서는 처리하지 않는다.
     * @param request - 모의용 출납처리 요청 데이터
     * @returns 모의용 출납처리 결과
     */
    requestDepositDemo(request) {
        return this.axios.get(`/main/v1/accounts/deposit/demo`, {
            params: request,
        });
    }
    /**
     * 예탁자산 조회
     * 계좌의 예탁자산(예수금, 증거금총액)을 조회한다.
     * @param accountNo - 계좌번호
     * @returns 예탁자산 조회 결과
     */
    getDepositAsset(accountNo) {
        return this.axios.get(`/main/v1/accounts/deposit-asset/${accountNo}`);
    }
    /**
     * 계좌비밀번호 확인
     * 사용자의 편의성을 위해 계좌의 비밀번호를 주문창 진입시 보여준다. 사용 계좌를 변경해도 새로 입력받는다.
     * @param request - 계좌비밀번호 확인 요청 데이터
     * @returns 계좌비밀번호 확인 결과
     */
    checkPassword(request) {
        return this.axios.get(`/main/v1/accounts/check/password`, {
            params: request,
        });
    }
    /**
     * 예수금/출금가능금액 조회
     * 계좌의 예수금/출금가능금액을 조회한다.
     * @returns 예수금/출금가능금액 조회 결과
     */
    getAvailableAmount() {
        return this.axios.get(`/main/v1/accounts/available/amount`);
    }
}
//# sourceMappingURL=account.service.js.map